var _path;
import * as React from "react";
function SvgChevronLightRight(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.536 4.254l-1.43 1.43a.867.867 0 000 1.227L24.163 20 11.105 33.089a.867.867 0 000 1.226l1.431 1.431a.867.867 0 001.227 0l15.132-15.133a.867.867 0 000-1.226L13.763 4.254a.867.867 0 00-1.227 0z"
  })));
}
export default SvgChevronLightRight;